import { alpha } from '@mui/material';
/**
 * Yellow colors by number from the lightest to the darkest
 */
export var yellow01 = '#ffe682';
export var yellow02 = '#f7d033';
export var yellow03 = '#d8ad00';
export var yellow04 = '#856a00';
export var yellow02opacity20 = alpha(yellow02, 0.2);
export var yellow02opacity30 = alpha(yellow02, 0.3);
